import * as yup from 'yup'

export const LoginValidationSchema = yup.object().shape({
  email: yup.string().email("1:Invalid email").required("1:Email is required"),
  password:yup.string().min(6,"2:Password must include at least 6 characters").required("2:Password is required")
});